import { Notification } from '@/utils/helpers/notification';

export default {
  name: 'insuranceDataIssues',

  data() {
    return {
      insuranceHasErrors: false,
    };
  },

  watch: {
    insuranceHasErrors(hasErrors) {
      if (hasErrors) {
        Notification.error({
          message: 'Parece que tem algum erro com seus dados de convênio.'
        });

        setTimeout(() => {
          this.$router.push(this.routerLinkParams);
          Notification.clearAll();
        }, 3000);
      }
    }
  },
};
